import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthenticationService } from '../core/services/authentication.service';
import { CommonService } from '../shared/services/common.service';
import { NgClass } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { NavbarComponent } from './navbar/navbar.component';

@Component({
    selector: 'app-aside',
    templateUrl: './aside.component.html',
    styleUrls: ['./aside.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, MatTooltip, NavbarComponent]
})
export class AsideComponent implements OnInit {

  public userAbbreviation = this._cs.userAbbreviation;
  public userInfo: any;
  public userName: string;
  public userEmail: string;

  constructor(private authentication: AuthenticationService, public _cs: CommonService) {    
    this.userInfo = JSON.parse(sessionStorage.getItem('UserInfo'));    
    if (this.userInfo != null) {
      this.userName = this.userInfo.UserName;
      this.userEmail = this.userInfo.Email || this.userInfo.EmailId;
      this.userAbbreviation = this.userInfo.UserName[0].toUpperCase();
    }
   }

   /**
    * @function slide()
    * @param None
    * @description When click the toogle icon side bar shown the icons only
    * @output None
    */
   slide() {
     this._cs.slideOpen = !this._cs.slideOpen;
   }
   closemenu() {
     this._cs.expandMenu = !this._cs.expandMenu;

   }

  ngOnInit() {

  }
}
